import React from 'react';
import _ from 'lodash';
import { connect, FormikContextType } from 'formik';
import { DailyBudgetPlan } from 'core/rtbCampaign/RtbCampaign';
import RtbCampaignInfo from 'components/RtbCampaignBasicForm/RtbCampaignInfo';
import moment from 'moment';
import CoreContext from 'contexts/coreContext';
import RtbCampaignOptimize from 'components/RtbCampaignBasicForm/RtbCampaignOptimize';
import { getFieldErrors } from 'utils/FormikUtils';
import { BidStrategy } from 'core/l2Object/L2Object';
import { RtbCampaignBasicFormModel } from './RtbCampaignBasicFormModel';

export class RtbCampaignBasicForm extends React.Component<{
  model: RtbCampaignBasicFormModel;
  formik: FormikContextType<any>;
}> {
  handler: number;
  constructor(props) {
    super(props);
    this.handleChangeDailyBudgetPlan =
      this.handleChangeDailyBudgetPlan.bind(this);
    this.handleGetBidFloor = this.handleGetBidFloor.bind(this);
    this.handleGetRemainBudget = this.handleGetRemainBudget.bind(this);
    this.handleGetCampaignTotalDay = this.handleGetCampaignTotalDay.bind(this);
    this.handleGetDailyBudgetState = this.handleGetDailyBudgetState.bind(this);
    this.handler = this.props.model.event.add((model) => {
      this.setState(model.state, () => {
        const { dailyBudgetType } = this.props.model.state;
        if (
          dailyBudgetType === _.get(this.props, 'formik.values.dailyBudgetType')
        ) {
          return;
        }
        let dailyTargetBudget: any = undefined;
        if (dailyBudgetType === DailyBudgetPlan.DAILY) {
          dailyTargetBudget = '0';
        }

        this.props.formik.setFieldValue('dailyTargetBudget', dailyTargetBudget);
      });
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.model !== this.props.model) {
      prevProps.model.event.remove(this.handler);
      this.handler = this.props.model.event.add((model) => {
        this.setState(model.state);
      });
    }
  }

  componentDidMount() {
    let dailyTargetBudget = _.get(
      this.props,
      'formik.values.dailyTargetBudget'
    );
    if (dailyTargetBudget === null) {
      dailyTargetBudget = undefined;
    }
    // wait for formik didMount flag set to true
    setTimeout(() => {
      this.props.formik.setFieldValue('dailyTargetBudget', dailyTargetBudget);
    }, 0);
  }

  componentWillUnmount() {
    this.props.model.onUnmount(this.handler);
  }

  handleChangeDayPartSwitch = (dayPartEnable: boolean) => {
    if (!dayPartEnable) {
      this.props.formik.setFieldValue('dayPart', undefined);
    }
  };

  handleOptimizeChanged = (newOptimize) => {
    if (this.props.model.showFrequencyControl(newOptimize)) {
      this.props.formik.setFieldValue('frequency', {
        intervalDays: 1,
        maxFrequency: 5
      });
    } else {
      this.props.formik.setFieldValue('frequency', undefined);
    }
  };

  handleChangeDailyBudgetPlan = (newBudgetPlan) => {
    this.props.model.changeDailyBudgetOptions(newBudgetPlan);
  };

  handleChangeSchedule = (startDate, endDate) => {
    const l1Object = this.props.model.l1Object;
    const order = this.props.model.order;
    if (
      l1Object &&
      l1Object.autoOptimise &&
      this.props.model.actionType === 'create'
    ) {
      const scheduleDateCount =
        moment(endDate).diff(moment(startDate), 'days') + 1;
      this.props.formik.setFieldValue(
        'budget',
        order.campaignConstraint.budgetMinimum * scheduleDateCount
      );
    }
  };

  handleChangePriceModel = (model) => {
    this.props.model.setCurrentPriceModel(model);
    this.props.model.onPriceModelChangeCallback(
      model,
      this.props.formik.values
    );
  };

  handleGetBidFloor() {
    const optimize = _.get(this.props, 'formik.values.optimize');
    return this.props.model.getBidFloor(optimize);
  }

  handleGetRemainBudget() {
    const campaignBudget = _.get(this.props, 'formik.values.budget', '');
    return this.props.model.getRemainBudget(campaignBudget);
  }

  handleGetCampaignTotalDay() {
    const startDate = _.get(this.props, 'formik.values.startDate');
    const endDate = _.get(this.props, 'formik.values.endDate');

    return this.props.model.getCampaignTotalDay(startDate, endDate);
  }

  handleGetDailyBudgetState() {
    const dailyBudget = _.get(this.props, 'formik.values.dailyTargetBudget');
    const budget = _.get(this.props, 'formik.values.budget');
    const campaignTotalDay = this.handleGetCampaignTotalDay();
    return this.props.model.getDailyBudgetState(
      +budget,
      +dailyBudget,
      campaignTotalDay
    );
  }

  handleChagneOrderPrice = (orderPrice) => {
    const formikValue = _.get(this.props, 'formik.values');
    const priceModel = _.get(formikValue, 'priceModel');
    const optimize = _.get(formikValue, 'optimize');
    const bidStrategy = _.get(formikValue, 'bidStrategy');
    if (bidStrategy === BidStrategy.LOWEST_COST_WITHOUT_CAP) {
      return;
    }
    const bidCapEqualOrderPrice = this.props.model.bidCapNeedAlignOrderPrice(
      priceModel,
      optimize
    );
    // 出價上限整段藏起來時（電子紙）也一律跟單價對齊：欄位不顯示，使用者沒地方填，
    // 但 bidStrategy 仍是「出價上限」，bidPrice 空著會卡在一個看不見的必填欄位上。
    const alignWithOrderPrice =
      bidCapEqualOrderPrice || this.props.model.onlyDaypartingOptimize;
    alignWithOrderPrice &&
      this.props.formik.setFieldValue('bidPrice', orderPrice);
  };

  render() {
    const {
      order,
      actionType,
      l1Object,
      priceModelOptions,
      optimizeOptions,
      campaignDeliverTypeOptions,
      creativeDeliverTypeOptions,
      outdoorDeliverTypeOptions,
      orderName,
      agencyProfit,
      currency,
      minDate,
      maxDate,
      canEditPriceModel,
      canEditBudgetPlan,
      canUseDailyBudget,
      campaignBasic: defaultCampaign,
      showOptimizeSection,
      optimizeAddonEnable,
      canEditVideoViewObjective,
      onlySupportAcceleratedDeliverType,
      onlyDaypartingOptimize,
      segmentOnlyDaypart,
      showDeliverType,
      getBidFloor,
      canEditOptimize,
      showFrequencyControl,
      getVideoAdViewObjectiveOptions
    } = this.props.model;

    const { dailyBudgetType } = this.props.model.state;
    const formikValue = _.get(this.props, 'formik.values');

    this.props.model.setFormikValue(formikValue);
    const dayPartEnable = _.get(formikValue, 'dayPart.enabled', 0);
    const priceModel = _.get(formikValue, 'priceModel');
    const optimize = _.get(formikValue, 'optimize');
    const dailyBudget = _.get(formikValue, 'dailyTargetBudget');
    const budget = _.get(formikValue, 'budget');

    const videoAdViewObjective = _.get(formikValue, 'videoAdViewObjective');
    const orderPrice = _.get(formikValue, 'orderPrice');
    const startDate = _.get(formikValue, 'startDate');
    const endDate = _.get(formikValue, 'endDate');
    const isNewCampaign =
      _.get(formikValue, 'id') === undefined ||
      _.get(formikValue, 'isDraft', false);
    const isCampaignStart =
      !isNewCampaign && moment(defaultCampaign.startDate).isBefore(moment());
    const tags = _.get(formikValue, 'tags', []);
    const dailyBudgetState = this.handleGetDailyBudgetState();
    const remainBudget = this.handleGetRemainBudget();
    const showOrderPriceHint = !getFieldErrors(this.props.formik, 'orderPrice');
    const showBudgetHint = !getFieldErrors(this.props.formik, 'budget');
    const bidFloor = getBidFloor(optimize);
    const orderPriceMinimum = optimizeAddonEnable
      ? getBidFloor(priceModel)
      : bidFloor;
    const videoAdViewObjectiveOptions = canEditVideoViewObjective
      ? getVideoAdViewObjectiveOptions(priceModel)
      : undefined;
    return (
      <CoreContext.Consumer>
        {() => {
          const renderCampaignInfo = () => {
            return (
              <RtbCampaignInfo
                formType={actionType}
                autoOptimise={l1Object.autoOptimise}
                editL1ObjectPath={`/orders/${order.orderNumber}/campaign-groups/${l1Object.l1ObjectId}/edit`}
                errors={this.props.formik.errors}
                orderName={orderName}
                startDate={startDate}
                endDate={endDate}
                minDate={minDate}
                maxDate={maxDate}
                isCampaignStart={isCampaignStart}
                canEditPriceModel={canEditPriceModel}
                priceModelOptions={priceModelOptions}
                campaignDeliverTypeOptions={campaignDeliverTypeOptions}
                orderPrice={orderPrice}
                showOrderPriceHint={showOrderPriceHint}
                agencyProfit={agencyProfit}
                currency={currency}
                priceModel={priceModel}
                canUseDailyBudget={canUseDailyBudget}
                canEditBudgetPlan={canEditBudgetPlan}
                dailyBudgetType={dailyBudgetType}
                onChangeDailyBudgetPlan={this.handleChangeDailyBudgetPlan}
                onChangePriceModel={this.handleChangePriceModel}
                onChangeSchedule={this.handleChangeSchedule}
                onChangeOrderPrice={this.handleChagneOrderPrice}
                dailyBudget={dailyBudget}
                budget={budget}
                videoAdViewObjective={videoAdViewObjective}
                videoAdViewObjectiveOptions={videoAdViewObjectiveOptions}
                dailyBudgetState={dailyBudgetState}
                remainBudget={remainBudget}
                orderPriceMinimum={orderPriceMinimum}
                showBudgetHint={showBudgetHint}
                showTagsPlaceholder={tags.length === 0}
                showOrderPriceField={_.get(formikValue, 'orderPriceEnable')}
                onlySupportAcceleratedDeliverType={
                  onlySupportAcceleratedDeliverType
                }
                showDeliverType={showDeliverType}
                deliverType={_.get(formikValue, 'deliverType')}
                adminBidPrice={_.get(formikValue, 'adminBidPrice')}
              />
            );
          };
          const renderCampaignOptimize = () => {
            if (!showOptimizeSection) {
              return undefined;
            }

            return (
              <RtbCampaignOptimize
                formType={actionType}
                canEditBidStrategy={this.props.model.canEditBidStrategy(
                  priceModel,
                  optimize
                )}
                currentL2Object={formikValue}
                optimizeOptions={optimizeOptions}
                currency={currency}
                canEditOptimize={canEditOptimize(priceModel)}
                optimizeAddonEnable={optimizeAddonEnable}
                onOptimizeChanged={this.handleOptimizeChanged}
                dayPartEnable={dayPartEnable}
                onDaypartSwitchChanged={this.handleChangeDayPartSwitch}
                bidFloor={bidFloor}
                creativeDeliverTypeOptions={creativeDeliverTypeOptions}
                outdoorDeliverTypeOptions={outdoorDeliverTypeOptions}
                showFrequencyControl={showFrequencyControl(optimize)}
                onlyDaypartingOptimize={onlyDaypartingOptimize}
                segmentOnlyDaypart={segmentOnlyDaypart}
              />
            );
          };
          return (
            <div>
              {renderCampaignInfo()}
              {renderCampaignOptimize()}
            </div>
          );
        }}
      </CoreContext.Consumer>
    );
  }
}

export default connect<{ model: RtbCampaignBasicFormModel }>(
  RtbCampaignBasicForm
);
